import { t } from "@lingui/macro";
import { Banner } from "@src/components/ui-kit";

const LastMonthNotClosed = () => (
  <Banner
    status="warning"
    mb="6"
    title={t`You have not closed last month, please do so.`}
  />
);

export default LastMonthNotClosed;
